<template>
    <div class="container">
        <!-- <div class="summary">
            <a-statistic
                title="当前可提现金额（元）"
                :value="data_summary.amount"
                style="margin-right: 50px"
            />

            <a-statistic
                title="处理中的提现金额（元）"
                :value="data_summary.amount_pend"
                style="margin-right: 50px"
            />

            <a-statistic
                title="累计成功提现金额（元）"
                :value="data_summary.amount_succeed"
                style="margin-right: 50px"
            />
        </div> -->
        <div class="toolbar">

            <div class="left-items">
                <a-button class="item" icon="icon icon-home" @click="on_reset" />
                <a-button class="item" ref="refresh" icon="icon icon-reset" @click="load()" />
                 <a-button class="item" type="primary" @click="visible_create = true" icon="plus">新增收款渠道</a-button>

            </div>

            <div class="right-items">
                <!-- <a-input-search
                    placeholder="搜索单号"
                    enter-button
                    @search="on_search"
                    class="item"
                    v-model="wd"
                />-->
            </div>
        </div>

        <div class="main">
            <a-table
                :columns="columns"
                :dataSource="data_source"
                rowKey="id"
                :loading="loading"
                :pagination="pagination"
                @change="on_pagination_change"
                :row-selection="{ selectedRowKeys: selected_row_keys, onChange: on_selection_change }"
                size="middle"
                :scroll="{ x: true }"
            >
                <!-- 状态 -->

                <!-- 状态 -->
                <template slot="audit_status" slot-scope="text, record">
                    <a-tag class="b-tag" v-if="text == 1">处理中</a-tag>
                    <a-tag color="green" class="b-tag" v-if="text == 2">已通过</a-tag>
                    <a-tag color="red" class="b-tag" v-if="text == 3">已拒绝</a-tag>
                </template>

                <template slot="member" slot-scope="text">
                    <div class="tbox" v-if="text">
                        <div class="a">{{ text.name }}</div>
                        <div class="b">ID：{{ text.id }}</div>
                    </div>
                </template>
                <template slot="transaction" slot-scope="text, record">
                    <span style="color:#ff9800" v-if="record.reject_msg"
                        ><a-icon type="exclamation-circle" style="margin-right:4px;" />{{ record.reject_msg }}</span
                    >
                    <span v-else>{{ text }}</span>
                </template>
                <!-- 申请人 -->
                <template slot="user" slot-scope="text, record">
                    <div class="tbox">
                        <div class="a">
                            {{ record.user ? record.user.name : "-" }}
                        </div>
                        <div class="b">
                            {{ moment(record.created_at * 1000).format("YYYY-MM-DD HH:mm") }}
                        </div>
                    </div>
                </template>
                <template slot="screenshot" slot-scope="text, record">
                    <a v-if="text" :href="text" target="_blank">查看</a>
                </template>
                <!-- 处理人 -->
                <template slot="executor" slot-scope="text, record">
                    <div class="tbox">
                        <div class="a">
                            {{ record.auditor ? record.auditor.name : "-" }}
                        </div>
                        <div class="b" v-if="record.executed_at">
                            {{ moment(record.executed_at * 1000).format("YYYY-MM-DD HH:mm") }}
                        </div>
                    </div>
                </template>

                <!-- 操作 -->
                <template slot="action" slot-scope="text, record">
                    <div class="action">
                        <a-button size="small" @click="on_approve(record)" style="margin-right:12px"
                            >删除</a-button
                        >
                    </div>
                </template>
            </a-table>
        </div>

      <modal_create :visible="visible_create" @close="visible_create = false" :callback="load" />

      <modal_reject
            type="recharge"
            @close="visible_reject = false"
            :visible="visible_reject"
            :transaction_no="selected_record.transaction_no"
            :callback="load"
        />
    </div>
</template>

<script>
    import moment from "moment";
    import common_pagination from "../../../../mixins/common_pagination.js";
    import commonjs from "../common/common.js";
    import modal_create from "./modal_create";
    import modal_reject from "../common/modal_reject";

    export default {
        mixins: [common_pagination, commonjs],
        components: { modal_reject,modal_create },

      data() {
            return {
                path: "/finance/audit/refund",
                data_source: [],
                loading: false,
                selected_record: {},
                wd: null,
                search: { audit_status: "" },
                visible_reject: false,
              visible_create: false,
              data_summary: {
                    amount: 0,
                    amount_pend: 0,
                    amount_succeed: 0,
                },
                columns: [
                  {
                    dataIndex: "id",
                    width: 20,
                    title: "ID",
                  },
                  {
                    dataIndex: "name",
                    width: 120,
                    title: "名称",
                  },
                  {
                    dataIndex: "bank",
                    width: 100,
                    title: "开户行",
                  },
                  {
                    dataIndex: "account",
                    title: "账号",
                    width: 120,
                  },
                  {
                    dataIndex: "remark",
                    title: "备注",
                    width: 120,
                  },
                  {
                    dataIndex: "created_at",
                    width: 100,
                    title: "添加时间",
                    customRender: (e) => (e ? moment(e * 1000).format("YYYY-MM-DD HH:mm") : ""),
                  },
                    {
                        dataIndex: "action",
                        width: 150,
                        align: "center",
                        fixed: "right",
                        title: "操作",
                        scopedSlots: {
                            customRender: "action",
                        },
                    },
                ],
            };
        },
        created() {
            this.$store.commit("change_state", {
                name: "sidebar_finance",
                value: "audit_refund",
            });
            this.load();
            this.reset_query();

            // this.load_summary();
        },
        watch: {
            $route() {
                this.reset_query();
                this.load();
            },
        },
        methods: {
            moment,
            reset_query() {
                let query = this.$route.query;

                this.wd = "wd" in query ? query["wd"] : "";
                this.search.status = Object.prototype.hasOwnProperty.call(query, "status") ? query["status"] : "";
            },
            load() {
                this.loading = true;

                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                this.$http
                    .get(`/finance/audit/refund?${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data;
                            this.pagination = {
                                pageSize: res.pagination.per_page,
                                total: res.pagination.total,
                                current: res.pagination.current_page,
                            };
                            this.load_stat();
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },
            on_create() {
                this.visible_create = true;
            },
            on_approve(record) {
                this.$confirm({
                    title: "是否删除？",
                    centered: true,
                    loading: true,
                    onOk: () => {
                        return new Promise((resolve) => {
                            this.$http
                                .post("/finance/audit/refund/approve", { id: record.id })
                                .then((res) => {
                                    if (res.success) {
                                        this.$message.success(res.message);
                                        this.load();
                                    } else {
                                        this.$error({
                                            title: "失败",
                                            centered: true,
                                            content: res.message,
                                        });
                                    }
                                })
                                .catch(() => {})
                                .then(() => {
                                    resolve();
                                });
                        }).catch();
                    },
                });
            },
        },
    };
</script>

<style lang="less" scoped>
    .container {
        .h2 {
            margin-top: 32px;
            margin-left: 16px;
        }
    }
</style>
